<template>
  <div>
    <div v-if="offerID > 0">
      <offerEdit :id-selected-offer="offerID" :from-add-to-offer="true"></offerEdit>
    </div>
    <div v-else>
      <b> {{ uniTranslation("PHE2233") }}</b>
    </div>
  </div>
</template>

<script>
import offerEdit from "@/views/OfferManagement/OfferEdit.vue";

export default {
  name: "OfferActive",
  components: {
    offerEdit
  },

  data() {
    return {
      offerID: -1,
      compName: "OffertaAttiva"
    };
  },

  computed: {},
  watch: {},
  mounted: function() {
    this.offerID = this.$store.getters.getIdOffertaAttiva;

    var that = this;
    //==========================================
    //MARCO DC 20/07/2021
    //Aggiunto su loro richiesta per mettere i titoli dei tab personalizzati

    document.getElementById("mainOverlay").setAttribute("style", "display: none;");

    document.getElementById("mainRouterView").setAttribute("style", "");

    document.getElementById("currentComponent").value = this.compName;
    that.impostaTitolo();
    that.$store.subscribe(function(mutation /*, state*/) {
      var comp = document.getElementById("currentComponent").value;

      if (mutation.type === "changeLanguage" && comp == that.compName) {
        that.impostaTitolo();
      }
    });
  },
  methods: {
    impostaTitolo: function() {
      const title = document.getElementById("title");
      title.innerHTML = this.$t("PHEOFFERTAATTIVA");
    }
  }
};
</script>
